import * as React from 'react';
import Shell from '../layout/shell';
import './signup.scss';
interface IMailChimpResult {
  msg: string;
  result: 'error' | 'success';
}
const SignUp: React.FC = () => {
  const url = `${typeof window !== 'undefined' ? window.location.origin : ''}/form.xhtml`;

  return (
    <Shell>
      <div className="signup-outer">
        <iframe className="signup-inner" src={url}></iframe>
      </div>
    </Shell>
  );
};

export default SignUp;
